import React from "react";

function DashboardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 36 36"
    >
      <path
        fill="#fff"
        d="M15.75 19.5H5.25c-.45 0-.75.3-.75.75v10.5c0 .45.3.75.75.75h10.5c.45 0 .75-.3.75-.75v-10.5c0-.45-.3-.75-.75-.75zM15 30H6v-9h9v9zm.75-25.5H5.25c-.45 0-.75.3-.75.75v10.5c0 .45.3.75.75.75h10.5c.45 0 .75-.3.75-.75V5.25c0-.45-.3-.75-.75-.75zM15 15H6V6h9v9zM30.75 4.5h-10.5c-.45 0-.75.3-.75.75v10.5c0 .45.3.75.75.75h10.5c.45 0 .75-.3.75-.75V5.25c0-.45-.3-.75-.75-.75zM30 15h-9V6h9v9zm.75 9.75h-4.5v-4.5c0-.45-.3-.75-.75-.75s-.75.3-.75.75v4.5h-4.5c-.45 0-.75.3-.75.75s.3.75.75.75h4.5v4.5c0 .45.3.75.75.75s.75-.3.75-.75v-4.5h4.5c.45 0 .75-.3.75-.75s-.3-.75-.75-.75z"
      ></path>
    </svg>
  );
}

export default DashboardIcon;
